import {
    IconButton,
    LinearProgress,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tooltip,
} from '@material-ui/core';
import React from 'react';
import FileDownloadIcon from '@material-ui/icons/GetApp';
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment';

import { useFetchContext } from '../../../common/FetchContext';
import { useReportFileTemplate } from '../../projectManagementQueries';


const useStyles = makeStyles({
    container: {
        padding: 24,
        display: 'flex',
        justifyContent: 'center',
    },
    table: {
        maxWidth: 800,
        minWidth: 500,
        border: '1px solid #ccc',
        borderRadius: 8,
    },
    header: {
        backgroundColor: '#f5f5f5',
        fontWeight: 'bold',
    },
    cell: {
        fontSize: 14,
        padding: '12px 16px',
    },
    row: {
        '&:hover': {
            backgroundColor: '#f0f8ff',
        },
    },
    iconButton: {
        color: '#1976d2',
        '&:hover': {
            color: '#004ba0',
        },
    },
});

export const ApproverFileUpload = ({ id }: { id: string }) => {
    const classes = useStyles();
    const { data: rows = [], isLoading: loadingRows } = useReportFileTemplate(id);

    const getDownload = (file: string) => {
        const link = document.createElement('a');
        link.href = file;
        link.setAttribute('download', file);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <div className={classes.container}>
            <div>
                {loadingRows ? (
                    <div
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            padding: 8,
                        }}
                    >
                        <LinearProgress />
                    </div>
                ) : (
                    <TableContainer component={Paper} className={classes.table}>
                        <Table>
                            <TableHead>
                                <TableRow className={classes.header}>
                                    <TableCell align="center" className={classes.cell}>ID</TableCell>
                                    <TableCell align="center" className={classes.cell}>NAME</TableCell>
                                    <TableCell align="center" className={classes.cell}>DATE</TableCell>
                                    <TableCell align="center" className={classes.cell}>USER</TableCell>
                                    <TableCell align="center" className={classes.cell}></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {rows.length === 0 ? (
                                    <TableRow>
                                        <TableCell colSpan={5} align="center">
                                            No uploaded files found.
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    rows.map((row: any) => (
                                        <TableRow key={row.id} className={classes.row}>
                                            <TableCell align="center" className={classes.cell}>{row.id}</TableCell>
                                            <TableCell align="center" className={classes.cell}>{row.name}</TableCell>
                                            <TableCell align="center" className={classes.cell}>
                                                {moment(row.datetime).format('DD-MMM-YYYY hh:mm A')}
                                            </TableCell>
                                            <TableCell align="center" className={classes.cell}>
                                                {row.username || 'N/A'}
                                            </TableCell>
                                            <TableCell align="center" className={classes.cell}>
                                                <Tooltip title="Download File">
                                                    <IconButton className={classes.iconButton} onClick={() => getDownload(row.file)}>
                                                        <FileDownloadIcon />
                                                    </IconButton>
                                                </Tooltip>
                                            </TableCell>
                                        </TableRow>
                                    ))
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
            </div>
        </div>
    );
};
